import axios from 'axios'

const BASE_PATH = '/api/v2/admins/sales/users'
const KYC_PREUPLOAD_PATH = '/api/v2/admins/sales/kyc_uploads'

const buildFormData = (file) => {
  const form = new FormData()
  form.append('file', file)
  return form
}

const normalizeEmail = (email) => String(email || '').trim().toLowerCase()

const SalesUsersApi = {
  // ✅ list/index (JSON)
  index: ({ params }) => axios.get(BASE_PATH, { params }),

  // ✅ backward compatible alias (your list page calls this)
  list: ({ q, page, per_page, start_at, end_at, state }) =>
    axios.get(BASE_PATH, {
      params: {
        q,
        page,
        per_page,
        start_at,
        end_at,
        state,
      },
    }),

  show: ({ userId }) => axios.get(`${BASE_PATH}/${userId}`),

  create: ({ payload }) => axios.post(BASE_PATH, { user: payload }),

  update: ({ userId, payload }) => axios.put(`${BASE_PATH}/${userId}`, { user: payload }),

  // ✅ Export CSV (BLOB)
  exportCsv: ({ q, start_at, end_at, state }) =>
    axios.get(`${BASE_PATH}/export_csv`, {
      params: { q, start_at, end_at, state },
      responseType: 'blob',
    }),

  // ✅ Create mode / new detail: preupload -> signed_id
  preuploadKycDocument: ({ file }) => {
    const form = buildFormData(file)
    return axios.post(KYC_PREUPLOAD_PATH, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  // ✅ Edit mode / existing detail: attach directly
  uploadDetailIdCard: ({ userId, detailId, file }) => {
    const form = buildFormData(file)
    return axios.post(`${BASE_PATH}/${userId}/details/${detailId}/id_card`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  deleteDetailIdCard: ({ userId, detailId }) => axios.delete(`${BASE_PATH}/${userId}/details/${detailId}/id_card`),

  kycUpdate: async ({ userId, state }) => {
    const path = `${BASE_PATH}/${userId}/kyc_update`
    const response = await axios.post(path, { state })
    return response
  },

  listHistory: async ({ userId }) => {
    const path = `${BASE_PATH}/${userId}/list_history`
    const response = await axios.get(path)
    return response
  },

  getHistory: async ({ userId, historyId }) => {
    const path = `${BASE_PATH}/${userId}/history/${historyId}`
    const response = await axios.get(path)
    return response
  },

  // ✅ Helper: find user by email via index search
  findByEmail: async ({ email }) => {
    const q = normalizeEmail(email)
    if (!q) return null

    const res = await axios.get(BASE_PATH, { params: { q, page: 1, per_page: 25 } })
    const users = res?.data?.users || []

    const exact =
      users.find((u) => normalizeEmail(u?.email) === q) ||
      users.find((u) => String(u?.email || '').toLowerCase().includes(q)) ||
      users[0]

    return exact || null
  },
}

export default SalesUsersApi
